/* src/app/shared/modals/audit-history/audit-history.component.css */
th {
  background-color: #a8e4e14d !important;
}
.row-toggle-icon {
  font-size: 1.2rem;
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  color: #1976d2;
}
.row-toggle-icon:hover {
  background: #e3f2fd;
}
.audit-table td {
  border-bottom: 1px solid #e0e0e0;
}
/*# sourceMappingURL=audit-history.component-U5C3ZXVV.css.map */
